import React, { useState } from 'react';

import cx from 'classnames';
import { IconContext } from 'phosphor-react';

import { List, X } from 'components/shared/Icon/phosphorIcons';
import Tooltip from 'components/shared/Tooltip';

import { useLandingV2Context } from '../../../context';
import { ELandingDeviceType, ILandingHeaderConfig } from '../../../types';
import { getPrefix } from '../../../utils';
import s from './index.module.css';
import { NavigationMenu } from './NavigationMenu';
import { IBurgerMenuProps } from './types';

export const BurgerMenu = ({ disabled = false }: IBurgerMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { config, deviceType } = useLandingV2Context();

  const openBurgerMenu = () => {
    if (disabled) {
      return null;
    }
    setIsOpen(!isOpen);
  };

  const burgerMenuClasses = cx(s.burgerButton, disabled && s.notAllowedCursor, getPrefix('burger-menu'));
  const BurgerIcon = isOpen && deviceType === ELandingDeviceType.Desktop ? X : List;

  return (
    <>
      <div data-tip data-for="burger_menu" onClick={openBurgerMenu} className={burgerMenuClasses}>
        <IconContext.Provider
          value={{
            width: 24,
            height: 23,
            weight: 'regular',
          }}
        >
          <BurgerIcon />
        </IconContext.Provider>
      </div>
      {!disabled && (
        <NavigationMenu config={config.header as ILandingHeaderConfig} isOpen={isOpen} setClose={setIsOpen} />
      )}
      <Tooltip id="burger_menu" disable={!disabled}>
        Active on live itinerary link when shared.
      </Tooltip>
    </>
  );
};
